import React from 'react';

function Image(props) {
    const fill = props.fill;
    const className = props.className;
    return (
        <svg 
            xmlns="http://www.w3.org/2000/svg" 
            width="23" 
            height="20" 
            viewBox="0 0 23 20" 
            fill="none"
            className={className}
        >
            <path 
                fillRule="evenodd" 
                clipRule="evenodd" 
                d="M13.5 19.75H9.5C5.53 19.75 3.53 19.75 2.14 18.36C0.75 16.97 0.75 14.97 0.75 11V9C0.75 5.03 0.75 3.03 2.14 1.64C3.53 0.25 5.52 0.25 9.5 0.25H13.5C17.47 0.25 19.47 0.25 20.86 1.64C22.25 3.03 22.25 5.03 22.25 9V11C22.25 14.97 22.25 16.97 20.86 18.36C19.47 19.75 17.48 19.75 13.5 19.75ZM9.5 1.75C5.94 1.75 4.15 1.75 3.2 2.7C2.25 3.65 2.25 5.44 2.25 9V11C2.25 12.4421 2.25 13.5938 2.31315 14.5169L5.09009 11.3899C5.79009 10.6099 7.13009 10.5699 7.87009 11.3099L9.50009 12.9399L13.6301 8.80995C14.3701 8.06995 15.6901 8.09995 16.4001 8.86995L20.7292 13.5941C20.75 12.8545 20.75 11.9966 20.75 11V9C20.75 5.44 20.75 3.65 19.8 2.7C18.85 1.75 17.06 1.75 13.5 1.75H9.5ZM20.5614 15.6081C20.4267 16.3627 20.1958 16.9042 19.8 17.3C18.85 18.25 17.06 18.25 13.5 18.25H9.5C5.94 18.25 4.15 18.25 3.2 17.3C2.95975 17.0597 2.78026 16.7658 2.64616 16.403L6.21009 12.3899C6.35009 12.2199 6.64009 12.2099 6.80009 12.3699L8.96009 14.5299C9.25009 14.8199 9.73009 14.8199 10.0201 14.5299L14.6801 9.86995C14.8401 9.70995 15.1301 9.70995 15.2901 9.87995L20.4401 15.4999C20.4773 15.5411 20.518 15.5772 20.5614 15.6081ZM8 8.75C6.76 8.75 5.75 7.74 5.75 6.5C5.75 5.26 6.76 4.25 8 4.25C9.24 4.25 10.25 5.26 10.25 6.5C10.25 7.74 9.24 8.75 8 8.75ZM8 5.75C7.59 5.75 7.25 6.09 7.25 6.5C7.25 6.91 7.59 7.25 8 7.25C8.41 7.25 8.75 6.91 8.75 6.5C8.75 6.09 8.41 5.75 8 5.75Z" 
                fill={fill}
            />
        </svg>
    )
};

export default Image;